"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
// (C) 2021-2022 GoodData Corporation
var Book_1 = require("./icons/Book");
var Lock_1 = require("./icons/Lock");
var Refresh_1 = require("./icons/Refresh");
var DrillDown_1 = require("./icons/DrillDown");
var DrillToDashboard_1 = require("./icons/DrillToDashboard");
var DrillToInsight_1 = require("./icons/DrillToInsight");
var Date_1 = require("./icons/Date");
var Explore_1 = require("./icons/Explore");
var Logout_1 = require("./icons/Logout");
var Pdf_1 = require("./icons/Pdf");
var ExternalLink_1 = require("./icons/ExternalLink");
var Hyperlink_1 = require("./icons/Hyperlink");
var Undo_1 = require("./icons/Undo");
var Home_1 = require("./icons/Home");
var BurgerMenu_1 = require("./icons/BurgerMenu");
var Rows_1 = require("./icons/Rows");
var DragHandle_1 = require("./icons/DragHandle");
var Interaction_1 = require("./icons/Interaction");
var AttributeFilter_1 = require("./icons/AttributeFilter");
var LegendMenu_1 = require("./icons/LegendMenu");
var ArrowDown_1 = require("./icons/ArrowDown");
var ArrowUp_1 = require("./icons/ArrowUp");
var Attribute_1 = require("./icons/Attribute");
var Close_1 = require("./icons/Close");
var Dataset_1 = require("./icons/Dataset");
var Expand_1 = require("./icons/Expand");
var Contract_1 = require("./icons/Contract");
var Fact_1 = require("./icons/Fact");
var Function_1 = require("./icons/Function");
var Insight_1 = require("./icons/Insight");
var Keyword_1 = require("./icons/Keyword");
var Label_1 = require("./icons/Label");
var Metric_1 = require("./icons/Metric");
var QuestionMark_1 = require("./icons/QuestionMark");
var Minimize_1 = require("./icons/Minimize");
var Dashboard_1 = require("./icons/Dashboard");
var Many_1 = require("./icons/Many");
var SettingsGear_1 = require("./icons/SettingsGear");
var AttachmentClip_1 = require("./icons/AttachmentClip");
var Error_1 = require("./icons/Error");
var Aborted_1 = require("./icons/Aborted");
var Progress_1 = require("./icons/Progress");
var Success_1 = require("./icons/Success");
var Table_1 = require("./icons/InsightIcons/Table");
var Column_1 = require("./icons/InsightIcons/Column");
var Bar_1 = require("./icons/InsightIcons/Bar");
var Line_1 = require("./icons/InsightIcons/Line");
var StackedArea_1 = require("./icons/InsightIcons/StackedArea");
var Combo_1 = require("./icons/InsightIcons/Combo");
var HeadlineChart_1 = require("./icons/InsightIcons/HeadlineChart");
var ScatterPlot_1 = require("./icons/InsightIcons/ScatterPlot");
var Bubble_1 = require("./icons/InsightIcons/Bubble");
var Pie_1 = require("./icons/InsightIcons/Pie");
var Donut_1 = require("./icons/InsightIcons/Donut");
var TreeMap_1 = require("./icons/InsightIcons/TreeMap");
var HeatMap_1 = require("./icons/InsightIcons/HeatMap");
var Bullet_1 = require("./icons/InsightIcons/Bullet");
var Geo_1 = require("./icons/InsightIcons/Geo");
var EmbedCodeIcon_1 = require("./icons/EmbedCodeIcon");
var Origin_1 = require("./icons/Origin");
var Token_1 = require("./icons/Token");
var Leave_1 = require("./icons/Leave");
var Copy_1 = require("./icons/Copy");
var Run_1 = require("./icons/Run");
var Invite_1 = require("./icons/Invite");
/**
 * @internal
 */
exports.Icon = {
    Book: Book_1.Book,
    Refresh: Refresh_1.Refresh,
    DrillDown: DrillDown_1.DrillDown,
    DrillToDashboard: DrillToDashboard_1.DrillToDashboard,
    DrillToInsight: DrillToInsight_1.DrillToInsight,
    Date: Date_1.Date,
    Explore: Explore_1.Explore,
    Logout: Logout_1.Logout,
    Lock: Lock_1.Lock,
    Pdf: Pdf_1.Pdf,
    ExternalLink: ExternalLink_1.ExternalLink,
    Hyperlink: Hyperlink_1.Hyperlink,
    Undo: Undo_1.Undo,
    Home: Home_1.Home,
    BurgerMenu: BurgerMenu_1.BurgerMenu,
    Rows: Rows_1.Rows,
    DragHandle: DragHandle_1.DragHandle,
    Interaction: Interaction_1.Interaction,
    AttributeFilter: AttributeFilter_1.AttributeFilter,
    LegendMenu: LegendMenu_1.LegendMenu,
    ArrowDown: ArrowDown_1.ArrowDown,
    ArrowUp: ArrowUp_1.ArrowUp,
    Attribute: Attribute_1.Attribute,
    Close: Close_1.Close,
    Dataset: Dataset_1.Dataset,
    Expand: Expand_1.Expand,
    Contract: Contract_1.Contract,
    Fact: Fact_1.Fact,
    Function: Function_1.Function,
    Insight: Insight_1.Insight,
    Keyword: Keyword_1.Keyword,
    Label: Label_1.Label,
    Metric: Metric_1.Metric,
    QuestionMark: QuestionMark_1.QuestionMark,
    Minimize: Minimize_1.Minimize,
    Dashboard: Dashboard_1.Dashboard,
    Many: Many_1.Many,
    SettingsGear: SettingsGear_1.SettingsGear,
    AttachmentClip: AttachmentClip_1.AttachmentClip,
    Table: Table_1.Table,
    Column: Column_1.Column,
    Bar: Bar_1.Bar,
    Line: Line_1.Line,
    StackedArea: StackedArea_1.StackedArea,
    Combo: Combo_1.Combo,
    HeadlineChart: HeadlineChart_1.HeadlineChart,
    ScatterPlot: ScatterPlot_1.ScatterPlot,
    Bubble: Bubble_1.Bubble,
    Pie: Pie_1.Pie,
    Donut: Donut_1.Donut,
    TreeMap: TreeMap_1.TreeMap,
    HeatMap: HeatMap_1.HeatMap,
    Bullet: Bullet_1.Bullet,
    Geo: Geo_1.Geo,
    EmbedCodeIcon: EmbedCodeIcon_1.EmbedCodeIcon,
    Error: Error_1.Error,
    Aborted: Aborted_1.Aborted,
    Progress: Progress_1.Progress,
    Success: Success_1.Success,
    Token: Token_1.Token,
    Origin: Origin_1.Origin,
    Leave: Leave_1.Leave,
    Copy: Copy_1.Copy,
    Run: Run_1.Run,
    Invite: Invite_1.Invite,
};
//# sourceMappingURL=Icon.js.map